import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../components/Main.vue'
import Callback from '../components/Callback.vue'
import Cellar from '../components/Cellar.vue'
import FakeLogin from '../components/FakeLogin.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Main
    },
    {
        path: '/oauth_callback',
        name: 'Callback',
        component: Callback,
        props: (route) => ({ code: route.query.code, })
    },
    {
        path: '/fakelogin',
        name: 'FakeLogin',
        component: FakeLogin,
        props: (route) => ({ cookie: route.query.cookie })
    },
    {
        path: '/cellar/:cname',
        name: 'Cellar',
        component: Cellar,
        props: (route) => ({cName: route.params.cname})
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router